type FormField = {
  field?: string;
  defaultValue?: unknown;
  [key: string]: unknown;
};

const readDiceAlertPostObject = (): {
  dice_server?: string;
  dice_port?: string;
} => {
  if (typeof localStorage === "undefined" || !localStorage.diceAlertPostObject) {
    return {};
  }

  try {
    return JSON.parse(localStorage.diceAlertPostObject);
  } catch {
    return {};
  }
};

const setFieldDefaultValue = (
  fields: FormField[],
  fieldName: string,
  value: unknown
) => {
  if (value === undefined || value === null || value === "") {
    return;
  }

  const field = fields.find((entry) => entry.field === fieldName);
  if (field) {
    field.defaultValue = value;
  }
};

export const checkFormsForDiceValues = (form: any): any => {
  if (!Array.isArray(form) || form.length === 0) {
    return form ?? [];
  }

  const diceAlertPostObject = readDiceAlertPostObject();
  const updatedForm = form.map((page: FormField[]) =>
    page.map((field: FormField) => ({ ...field }))
  );
  const lastPage = updatedForm[updatedForm.length - 1];

  if (!Array.isArray(lastPage) || lastPage.length === 0) {
    return updatedForm;
  }

  setFieldDefaultValue(
    lastPage,
    "dice_server",
    diceAlertPostObject.dice_server
  );
  setFieldDefaultValue(lastPage, "dice_port", diceAlertPostObject.dice_port);

  return updatedForm;
};
